import React from 'react';
import { Input } from 'rsuite5';
import { PrependParameters } from 'rsuite5/esm/@types/utils';

const BicesterInput = ({
  className,
  style,
  placeholder = '',
  type,
  as,
  onChange,
  onPressEnter,
  ...props
}: {
  className?: string;
  style?: any;
  placeholder?: string;
  type?: string;
  as?: React.ElementType<any>;
  value?: string;
  onChange?: PrependParameters<React.ChangeEventHandler<HTMLInputElement>, [value: string]>;
  onPressEnter?: React.KeyboardEventHandler<HTMLInputElement>;
  [rest: string]: any;
}) => {
  return (
    <Input
      className={className}
      style={style}
      type={type}
      as={as}
      placeholder={placeholder}
      onChange={onChange}
      onPressEnter={onPressEnter}
      {...props}
    />
  );
};

export default BicesterInput;
